import React from 'react';
import { useSelector } from 'react-redux';
import { FinalButtonType } from '../../../../enums/FinalButtonType';
import BtnComponent from '../../../ui/buttons/BtnComponent';
import classes from './FinalButton.module.css';
import { ButtonType } from '../../../../ui/buttonTypes';

const FinalButton = ({ finalButtonType, studentInFinalTeam }) => {

  const { texts } = useSelector((state) => state.translate);

  const renderContent = () => {
    switch (finalButtonType) {
      case FinalButtonType.locked:
        return <BtnComponent type={ButtonType.FINAL_LOCKED} text={texts.textStudentInFinalTeamBtn} className={classes.wrapper} />
      case FinalButtonType.finalDayStudent:
        return <BtnComponent type={ButtonType.FINAL_DAY_STUDENT} text={texts.textStudentInFinalTeamBtn} className={classes.wrapper} />;
      case FinalButtonType.finalDayStudentWithPopup:
        return <BtnComponent type={ButtonType.FINAL_DAY_STUDENT} text={texts.textStudentInFinalTeamBtn} className={classes.wrapper} showPopupFinalEntryPopup={true} />;
      case FinalButtonType.teacherRegister:
        return <BtnComponent type={ButtonType.REGISTERFORFINAL} text={texts.registerForFinal} />;
      case FinalButtonType.updateRegistration:
        return <BtnComponent type={ButtonType.REGISTERFORFINAL} text={texts.updateRegistrationForFinal} bgcolor="#F2AD22" color="white" icon="none" borderColor="#F2AD22" />;
      case FinalButtonType.finalistsList:
        return <BtnComponent type={ButtonType.FINALISTS_LIST} showFinalistsListPopup={true} />;
      default:
        return null;
    }
  };

  return renderContent();
};

export default FinalButton;
